import { useRef } from 'react';
import styles from './MenuLink.module.css';
import { useTextReveal } from '@/hooks/useRevealAnimations';
import { useCursor } from '@/contexts/CursorContext';

export const MenuLink = ({
  label,
  index,
  isActive,
  isOpen,
  onClick,
}: {
  label: string;
  index: number;
  isActive: boolean;
  isOpen: boolean;
  onClick: () => void;
}) => {
  const ref = useRef<HTMLHeadingElement>(null);

  const { setState } = useCursor();

  const onMouseEnter = () => {
    setState('link');
  };

  const onMouseLeave = () => {
    setState('default');
  };

  useTextReveal(ref.current, {
    enabled: isOpen,
    stagger: 0.3,
    yStart: 100,
    delay: index * 0.2,
  });

  return (
    <h1
      ref={ref}
      className={`${styles.navLink} ${isActive ? styles.gradientWord : ''} `}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <span>{label}</span>
    </h1>
  );
};
